var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wk-select" },
    [
      _vm.valueIsObject
        ? [
            _vm.showType === "default"
              ? _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.disabled,
                      clearable: _vm.clearable,
                      placeholder: _vm.placeholder,
                    },
                    on: { change: _vm.valueChange },
                    model: {
                      value: _vm.dataValue.select,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataValue, "select", $$v)
                      },
                      expression: "dataValue.select",
                    },
                  },
                  _vm._l(_vm.options, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: !_vm.isEmptyValue(item.value)
                          ? item.label || item.name
                          : item,
                        value: _vm.getValue(item),
                      },
                    })
                  }),
                  1
                )
              : _vm.showType === "tiled"
              ? _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.valueChange },
                    model: {
                      value: _vm.dataValue.select,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataValue, "select", $$v)
                      },
                      expression: "dataValue.select",
                    },
                  },
                  _vm._l(_vm.options, function (item, index) {
                    return _c(
                      "el-radio",
                      { key: index, attrs: { label: _vm.getValue(item) } },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              !_vm.isEmptyValue(item.value)
                                ? item.label || item.name
                                : item
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataValue.select === "其他" && _vm.otherShowInput
              ? _c("el-input", {
                  attrs: {
                    disabled: _vm.disabled,
                    maxlength: 100,
                    placeholder: "其他选项需填写，否则为无效选项",
                  },
                  on: { blur: _vm.inputBlur },
                  model: {
                    value: _vm.dataValue.otherValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataValue, "otherValue", $$v)
                    },
                    expression: "dataValue.otherValue",
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }